import React from 'react';
export var containerAlign = ['center', 'left', 'right'];
export var defaultContainerContext = {
  containerAlign: 'center',
  containerMaxWidth: undefined
};
export var ContainerContext = /*#__PURE__*/React.createContext(defaultContainerContext);